import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';

import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import Dropdown from '@grnhse/seedling/lib/azalea/components/dropdown_select';
import { withLocalePrefix } from 'shared/utils/translation';

// A time dropdown with 15-minute granularity. Labels are in am/pm,
// and the value is padded 24-hour, e.g. '06:45'.

const t = withLocalePrefix('shared');

export default class TimeSelect extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
    ]),
    className: PropTypes.string,
    clearable: PropTypes.bool,
    openOnFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    valueType: PropTypes.string,
    withMinutes: PropTypes.bool,
    useBirchDropdown: PropTypes.bool,
    birchLabel: PropTypes.string,
    birchError: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    clearable: false,
    openOnFocus: true,
    placeholder: t('time.time'),
    style: {},
    valueType: 'string',
    withMinutes: true,
    useBirchDropdown: false,
  };

  static hours = [
    6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 0, 1, 2,
    3, 4, 5,
  ];
  static minutes = [0, 15, 30, 45];

  constructor(props) {
    super(props);

    this.minutes = this.props.withMinutes ? this.constructor.minutes : [0];
    this.options = this.getOptions();
  }

  paddedNumber(number) {
    return ('00' + number).slice(-2);
  }

  calculateValue(hour, minute) {
    switch (this.props.valueType) {
      case 'string':
        return this.paddedNumber(hour) + ':' + this.paddedNumber(minute);
      case 'minutes':
        return hour * 60 + minute;
    }
  }

  getOptions() {
    return _.flatten(
      this.constructor.hours.map((hour) => {
        return this.minutes.map((minute) => {
          const meridian = hour < 12 ? 'am' : 'pm';
          const hour12 = hour < 13 ? hour : hour - 12;

          return {
            label: `${hour12 || 12}:${this.paddedNumber(minute)} ${meridian}`,
            value: this.calculateValue(hour, minute),
          };
        });
      })
    );
  }

  render() {
    const {
      valueType,
      value,
      useBirchDropdown,
      birchLabel,
      birchError,
      ...props
    } = this.props;

    const valueOption =
      typeof value === 'string' || typeof value === 'number'
        ? this.options.find((o) => o.value === value)
        : value;

    if (useBirchDropdown) {
      return (
        <SimpleSingleDropdown
          label={birchLabel}
          items={this.options}
          selectedItem={valueOption}
          onSelectedItemChange={props.onChange}
          clearable={false}
          error={!!birchError}
          helperText={birchError}
        />
      );
    }

    return <Dropdown options={this.options} value={valueOption} {...props} />;
  }
}
